import { Component, Input, Output, EventEmitter } from '@angular/core';
import {emitInfoMessage, InfoMessageService} from "../services/info-message.service";
import {ApiGatewayService} from "../services/api-gateway.service";
import {MotdService} from "../services/motd.service";

export interface MessageOfTheDay {
  severity: string,
  textTag: string,
  textBody: string,
  id:number
 }

@Component({
    selector: 'motd',
    templateUrl: './motd.component.html',
    standalone: false
})
export class MotdComponent {
  messagesFrontendFormat: MessageOfTheDay[] = [];
  currentMessage?: MessageOfTheDay;
  showMessages: boolean = false;

  constructor(
    private infoMessageService: InfoMessageService,
    private gatewayApiService: ApiGatewayService,
    private motdService: MotdService
  ){
    this.motdService.refreshMessages$.subscribe(() => {
      this.getMessagesOfTheDay();
    });

    this.getMessagesOfTheDay();
  }

  async getMessagesOfTheDay() {
    const hiddenIds = new Set(this.motdService.getHiddenMessageIds());

    await this.gatewayApiService.getMessagesOfTheDay()
      // when ok request, handle the returned messages
      .then((data) => {
        this.messagesFrontendFormat = [];
        data.body?.forEach(
          message => {
            // Only add message if it's not hidden
            if (!hiddenIds.has(message.id)) {
              this.messagesFrontendFormat.push(
                {severity: 'info', textTag: 'Info', textBody: message.message_text, id: message.id}
              )
            }
          }
        )

        // Only show messages if there are any visible messages
        if (this.messagesFrontendFormat.length > 0) {
          this.showMessages = true;
          this.currentMessage = this.messagesFrontendFormat[0];
        } else {
          this.showMessages = false;
          this.currentMessage = undefined;
        }
      })
      // when error in request, show error to user
      .catch((error) => {
        emitInfoMessage(error.status + ": " + error.statusText, this.infoMessageService)
      })
  }

  close(){
    const messageIds = this.messagesFrontendFormat.map(msg => msg.id);
    this.motdService.hideMessages(messageIds);

    this.showMessages = false;
    this.currentMessage = undefined;
  }

  displayMessages() {
    return this.showMessages;
  }

  setMessage(message: MessageOfTheDay) {
    this.currentMessage = message;
  }
}
